module.exports = __webpack_public_path__ + "static/BT-desktop-17-cac8df1fc52a5254b9cbaf07fde46fd1.jpg";